import { get } from '@fogia/core-web/libs/GrebbCommerceAPI/util';

export default async () => {
    const response = await get('/frontend/products/stock');
    return await response.body();
};
